import PropTypes from 'prop-types';

/** PropTypes for a HomeVideo (typedef in ../api/useHomepageVideos.js). */
export const resourceShape = PropTypes.shape({
  title: PropTypes.string,
  description: PropTypes.string,
  url: PropTypes.string.isRequired
});

export const videoShape = PropTypes.shape({
  id: PropTypes.number.isRequired,
  youtubeVideoId: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  description: PropTypes.string,
  durationSeconds: PropTypes.number,
  thumbnailUrl: PropTypes.string,
  homePosition: PropTypes.number,
  transcript: PropTypes.string,
  readTimeMinutes: PropTypes.number,
  resource: resourceShape
});
